const state = {
  commodities: uni.getStorageSync('commodities') || [],
  presentVO: uni.getStorageSync('presentVO') || '',
};
const mutations = {
  SET_COMMODITIES(state, value) {
    state.commodities = value;
    uni.setStorageSync('commodities', value);
  },
  SET_PRESENT_VO(state, value) {
    state.presentVO = value;
    uni.setStorageSync('presentVO', value);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
